import { useEffect, useRef } from "react";

interface IDXListingsWidgetProps {
  widgetId: string;
}

const IDXListingsWidget = ({ widgetId }: IDXListingsWidgetProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!widgetId || !containerRef.current) return;

    const script = document.createElement("script");
    script.charset = "UTF-8";
    script.type = "text/javascript";
    script.id = `idxwidgetsrc-${widgetId}`;
    script.src = `//homes.prpsj.com/idx/widgets/${widgetId}`;
    script.async = true;
    containerRef.current.appendChild(script);

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = "";
      }
    };
  }, [widgetId]);

  return (
    <div>
      <div ref={containerRef} className="idx-widget-container min-h-[400px]" />
      {/* Dev notice — only visible in non-production environments */}
      {typeof window !== "undefined" && window.location.hostname !== "www.prpsj.com" && (
        <p className="text-xs text-muted-foreground text-center mt-4 italic">
          IDX Broker widgets only render on the registered domain (prpsj.com). 
          This area will display live MLS listings on the production site.
        </p>
      )}
    </div>
  );
};

export default IDXListingsWidget;
